import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { OfficeService } from "./office.service";
import { DataSelectors } from "@app/store/data/data.selectors";

@Injectable({
    providedIn: 'root'
})
export class StaffService {
    constructor(private store: Store, private officeService: OfficeService) { }
    get staffList() {
        return this.store.selectSnapshot(DataSelectors.staffList(this.officeService.officecd)) || [];
    }

    get teamList() {
        return this.store.selectSnapshot(DataSelectors.staffTeamList(this.officeService.officecd)) || [];
    }
}